import React, { useState } from 'react';
import './Header.css';
import { Link, NavLink } from 'react-router-dom';
import { GiHamburgerMenu } from "react-icons/gi";
import { images } from '../../assets';


const Header = () => {
  const [showMenu, setShowMenu] = useState(false);

  const toggleMenu = () => {
    setShowMenu(!showMenu);
  };

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
    setShowMenu(false); // Close the menu after clicking a link
  };

  return (
    <div className='header container'>
      <div className='logo'>
        <Link to='/'><img src={images.impactLogo} alt="logo" /></Link>
      </div>


      <div className={showMenu ? "menu-link mobile-menu-link" : "menu-link"}>
        <ul>
          <li> <NavLink to="/" className='navlink' activeclassname="active" onClick={scrollToTop} >Home </NavLink></li>
          <li> <NavLink to="/offerings" className='navlink' activeclassname="active" onClick={scrollToTop} >Offerings </NavLink></li>
          <li> <NavLink to="/about" className='navlink' activeclassname="active" onClick={scrollToTop} >About </NavLink></li>
          <li> <NavLink to="/careers" className='navlink' activeclassname="active" onClick={scrollToTop} >Join Us </NavLink></li>
          <li> <NavLink to="/contact" className='navlink' activeclassname="active" onClick={scrollToTop} >Contact </NavLink></li>
        </ul>
      </div>

      

      <div className={showMenu ? 'dButton mobile-button' : 'dButton'}>
        <div className='download'>
          <Link to='http://onelink.to/impact_web' target='_blank' >Download Now </Link>
          <img src={images.download} alt="Download Icon" />
        </div>
      </div>

        <div className="hamburgerMenu" onClick={toggleMenu}>
        <GiHamburgerMenu />
      </div>
    </div>
  );
}

export default Header;
